import * as React from 'react';
import Box from '@mui/material/Box';
import axios from "axios";
import ModalUsuarios from "../Componentes/Usuarios/ModalUsuario";
import { useState, useEffect } from 'react';
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import { Button } from 'react-bootstrap';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModalEditarUsuario from '../Componentes/Usuarios/EditarUsuario';

export default function TablaUsuarios() {
    const URIUsuarios = "https://invio.datachile.site/Web/Usuarios/ObtenerUsuarios.php";
    const eliminarUsuarioURL = "https://invio.datachile.site/Web/Usuarios/EliminarUsuario.php";
    const [usuarios, setUsuarios] = useState([]);
    const [empresa_idEmpresa, setEmpresaIdEmpresa] = useState('');

    useEffect(() => {
        // Obtener empresa_idEmpresa del localStorage
        const usuario = JSON.parse(localStorage.getItem('usuario'));

        if (usuario && usuario.empresa_idEmpresa) {
            setEmpresaIdEmpresa(usuario.empresa_idEmpresa);
            console.log('empresa_idEmpresa:', usuario.empresa_idEmpresa);
            // Cargar usuarios al cargar el componente
            getUsuarios(usuario.empresa_idEmpresa);
        }
    }, []);

    // Procedimiento para obtener los usuarios
    const getUsuarios = async (empresaId) => {
        try {
            const res = await axios.get(`${URIUsuarios}?empresa_idEmpresa=${empresaId}`);
            setUsuarios(res.data);
            console.log(res.data);
        } catch (error) {
            console.error('Error al obtener usuarios:', error);
        }
    };

    // Procedimiento para eliminar un usuario
    const deleteUsuario = async (idUsuarios) => {
        try {
            // Mostrar confirmación al usuario
            const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este usuario?');
            if (!confirmDelete) return;
           

            // Construir el cuerpo del JSON a enviar
            const data = {
                id: idUsuarios,
                empresa_idEmpresa: empresa_idEmpresa,
            };

            // Enviar datos como JSON en el cuerpo
            const res = await axios.post(eliminarUsuarioURL, data);

            console.log('ID de usuario eliminado:', idUsuarios);
            getUsuarios(empresa_idEmpresa); // Recargar usuarios
        } catch (error) {
            console.error('Error al eliminar usuario:', error);
        }
    };
    

    return (
        <Container maxWidth="xl">
            <h2 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Gestión de Usuarios</h2>
            <Box sx={{ marginLeft: "78%" }}>
                <ModalUsuarios />
            </Box>
            <div className="table-responsive">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th scope="col">Nombre</th>
                            <th scope="col">Correo</th>
                            <th scope="col">Usuario</th>
                            <th scope="col">Rut</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody style={{ height: "100%" }}>
                        {usuarios.map((item) => (
                            <tr key={item.idUsuarios}>
                                <td className='centrar'>{item.nombre}</td>
                                <td className='centrar'>{item.correo}</td>
                                <td className='centrar'>{item.usuario}</td>
                                <td className='centrar'>{item.rut}</td>
                                <td style={{ display: 'flex', gap: '10px', maxWidth: '100px' }}>
                                    <Button variant="danger" onClick={() => deleteUsuario(item.idusuarios)}>
                                        <DeleteForeverIcon />
                                    </Button>
                                    <ModalEditarUsuario usuarios={item} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Container>
    );
}
